export const getCareScore = (
	careScore?: number,
	careDateCompleted?: string,
	careTestResultId?: number,
) => {
	if (careScore) {
		return careScore;
	} else if (careDateCompleted) {
		return "C";
	} else if (!careTestResultId) {
		return "-";
	}

	return "NC";
};


export const getCareRecommendation = (
	careRecommendation?: string,
) => {
	if (careRecommendation === "RangeOfInquiry") {
		return "Range of Inquiry";
	} return "";
};